/* TODO: Remove password restrictions when .NET legacy is not needed anymore */

/* Fixes infinity loop when user tries to authenticate using a password that contains unsupported chars

    When user logs in with invalid chars, core api accepts the session but the legacy returns an error,
    leading the user to a inconsist state where they are actually logged-in but a second login box is shown.

Some invalid passwords we discovered:
"123€456" → €
"123ab56 " → whitespaces around
UTF8 chars or emojis.
*/

/* Maybe we could use this variable to create the regex so        */
/*  we don't need to update two times if we want to add more syms */
export const PASSWORD_PERMITTED_SYMBOLS = '!@#$%&=+*_~`^*(){[}]|\\:;"\'<,>.?-'

export const PASSWORD_RULES = {
  required: true,
  /* regex: /^(?!\s)([a-zA-Z0-9\s!@#$%&=+*~`^()_{[}\]|\\:;"'<,>.?/-])*?(?<!\s)$/, --> Safari can't handle Lookbehind (probably neither Lookahead)  */
  regex: /^([a-zA-Z0-9!@#$%&=+*~`^()_{[}\]|\\:;"'<,>.?/-])([a-zA-Z0-9\s!@#$%&=+*~`^()_{[}\]|\\:;"'<,>.?/-])*?([a-zA-Z0-9!@#$%&=+*~`^()_{[}\]|\\:;"'<,>.?/-])$/,
  min: 6
}
